import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "content-header" }
const _hoisted_2 = { class: "container-fluid" }
const _hoisted_3 = { class: "row mb-2" }
const _hoisted_4 = { class: "col-sm-6" }
const _hoisted_5 = { class: "col-sm-6" }
const _hoisted_6 = { class: "breadcrumb float-sm-right" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("li", { class: "breadcrumb-item" }, [
  /*#__PURE__*/_createElementVNode("a", { href: "#" }, "Home")
], -1)
const _hoisted_8 = { class: "breadcrumb-item active" }
const _hoisted_9 = { class: "content" }
const _hoisted_10 = { class: "container-fluid" }
const _hoisted_11 = { class: "card" }
const _hoisted_12 = { class: "card-header" }
const _hoisted_13 = { class: "card-title" }
const _hoisted_14 = { class: "form-row" }
const _hoisted_15 = { class: "form-group col-sm-6" }
const _hoisted_16 = { for: "id_category" }
const _hoisted_17 = { value: "" }
const _hoisted_18 = ["value"]
const _hoisted_19 = { class: "form-group col-sm-6" }
const _hoisted_20 = { for: "type" }
const _hoisted_21 = { value: "" }
const _hoisted_22 = ["value"]
const _hoisted_23 = { class: "form-row" }
const _hoisted_24 = { class: "form-group col-12 col-sm-6" }
const _hoisted_25 = { for: "price" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_27 = { class: "form-row" }
const _hoisted_28 = { class: "form-group col-5" }
const _hoisted_29 = {
  class: "form-group col-2",
  style: {"text-align":"center"}
}
const _hoisted_30 = { class: "form-group col-5" }
const _hoisted_31 = { class: "form-group col-12 col-sm-6" }
const _hoisted_32 = { for: "description" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_34 = { class: "form-row" }
const _hoisted_35 = { class: "form-group col-12 col-sm-6" }
const _hoisted_36 = { for: "name" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_38 = { class: "form-group col-12 col-sm-6" }
const _hoisted_39 = { for: "code_video_external" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_41 = { class: "card-tools" }
const _hoisted_42 = { class: "card-tools" }
const _hoisted_43 = ["title"]
const _hoisted_44 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-redo",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_45 = [
  _hoisted_44
]
const _hoisted_46 = ["title"]
const _hoisted_47 = /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-plus",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_48 = [
  _hoisted_47
]
const _hoisted_49 = { class: "card-body table-body" }
const _hoisted_50 = {
  class: "table-button-container",
  style: {"text-align":"center"}
}
const _hoisted_51 = { class: "btn-group" }
const _hoisted_52 = ["onClick", "title"]
const _hoisted_53 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-eye" }, null, -1)
const _hoisted_54 = [
  _hoisted_53
]
const _hoisted_55 = ["onClick", "title"]
const _hoisted_56 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-pencil-alt" }, null, -1)
const _hoisted_57 = [
  _hoisted_56
]
const _hoisted_58 = ["onClick", "title"]
const _hoisted_59 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash" }, null, -1)
const _hoisted_60 = [
  _hoisted_59
]

export function render(_ctx, _cache) {
  const _component_table_lite = _resolveComponent("table-lite")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h1", null, _toDisplayString(_ctx.$t("labels.page.product")), 1)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("ol", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("li", _hoisted_8, _toDisplayString(_ctx.$t("labels.page.product")), 1)
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("h3", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.$t("labels.entity.category")), 1),
                  _withDirectives(_createElementVNode("select", {
                    id: "id_category",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.filterProduct.id_category) = $event)),
                    style: {"width":"auto","max-width":"-webkit-fill-available"},
                    class: "form-control"
                  }, [
                    _createElementVNode("option", _hoisted_17, _toDisplayString(_ctx.$t("labels.select")), 1),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categorys, (i, k) => {
                      return (_openBlock(), _createElementBlock("option", {
                        value: i.id,
                        key: k
                      }, _toDisplayString(i.description), 9, _hoisted_18))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, _ctx.filterProduct.id_category]
                  ])
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("label", _hoisted_20, _toDisplayString(_ctx.$t("labels.entity.type")), 1),
                  _withDirectives(_createElementVNode("select", {
                    id: "type",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.filterProduct.type) = $event)),
                    style: {"width":"auto","max-width":"-webkit-fill-available"},
                    class: "form-control"
                  }, [
                    _createElementVNode("option", _hoisted_21, _toDisplayString(_ctx.$t("labels.select")), 1),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.types, (i, k) => {
                      return (_openBlock(), _createElementBlock("option", {
                        value: i.id,
                        key: k
                      }, _toDisplayString(i.description), 9, _hoisted_22))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, _ctx.filterProduct.type]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("label", _hoisted_25, _toDisplayString(_ctx.$t("labels.entity.price")), 1),
                  _hoisted_26,
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("div", _hoisted_28, [
                      _withDirectives(_createElementVNode("input", {
                        id: "priceIni",
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((_ctx.filterProduct.priceIni) = $event)),
                        type: "text",
                        class: "form-control"
                      }, null, 512), [
                        [_vModelText, _ctx.filterProduct.priceIni]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_29, _toDisplayString(_ctx.$t("labels.to")), 1),
                    _createElementVNode("div", _hoisted_30, [
                      _withDirectives(_createElementVNode("input", {
                        id: "priceEnd",
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => ((_ctx.filterProduct.priceEnd) = $event)),
                        type: "text",
                        class: "form-control"
                      }, null, 512), [
                        [_vModelText, _ctx.filterProduct.priceEnd]
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_31, [
                  _createElementVNode("label", _hoisted_32, _toDisplayString(_ctx.$t("labels.entity.description")), 1),
                  _hoisted_33,
                  _withDirectives(_createElementVNode("input", {
                    id: "description",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => ((_ctx.filterProduct.description) = $event)),
                    type: "text",
                    class: "form-control"
                  }, null, 512), [
                    [_vModelText, _ctx.filterProduct.description]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_34, [
                _createElementVNode("div", _hoisted_35, [
                  _createElementVNode("label", _hoisted_36, _toDisplayString(_ctx.$t("labels.entity.name")), 1),
                  _hoisted_37,
                  _withDirectives(_createElementVNode("input", {
                    id: "name",
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => ((_ctx.filterProduct.name) = $event)),
                    type: "text",
                    class: "form-control"
                  }, null, 512), [
                    [_vModelText, _ctx.filterProduct.name]
                  ])
                ]),
                _createElementVNode("div", _hoisted_38, [
                  _createElementVNode("label", _hoisted_39, _toDisplayString(_ctx.$t("labels.entity.code_video_external")), 1),
                  _hoisted_40,
                  _withDirectives(_createElementVNode("input", {
                    id: "code_video_external",
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => ((_ctx.filterProduct.code_video_external) = $event)),
                    type: "text",
                    class: "form-control"
                  }, null, 512), [
                    [_vModelText, _ctx.filterProduct.code_video_external]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_41, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-sm btn-info",
                  onClick: _cache[7] || (_cache[7] = (...args) => (_ctx.doFilter && _ctx.doFilter(...args)))
                }, _toDisplayString(_ctx.$t('labels.search')), 1),
                _createTextVNode("   "),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-sm btn-default",
                  onClick: _cache[8] || (_cache[8] = (...args) => (_ctx.clear && _ctx.clear(...args)))
                }, _toDisplayString(_ctx.$t('labels.buttons.clean')), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_42, [
              _createElementVNode("button", {
                id: "newButton",
                class: "btn btn-sm btn-default btn-new",
                onClick: _cache[9] || (_cache[9] = $event => (_ctx.reload())),
                style: {"width":"33px"},
                title: _ctx.$t('labels.buttons.reload')
              }, _hoisted_45, 8, _hoisted_43),
              _createTextVNode("   "),
              (_ctx.hasPermission('create'))
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    id: "newButton",
                    class: "btn btn-sm btn-primary btn-new",
                    onClick: _cache[10] || (_cache[10] = $event => (_ctx.newRow())),
                    style: {"width":"33px"},
                    title: _ctx.$t('labels.buttons.new')
                  }, _hoisted_48, 8, _hoisted_46))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_49, [
            _createVNode(_component_table_lite, {
              "is-slot-mode": true,
              "is-loading": _ctx.table.isLoading,
              columns: _ctx.table.columns,
              rows: _ctx.table.rows,
              total: _ctx.table.totalRecordCount,
              sortable: _ctx.table.sortable,
              messages: _ctx.table.messages,
              onDoSearch: _ctx.doSearch,
              onIsFinished: _cache[11] || (_cache[11] = $event => (_ctx.table.isLoading = false))
            }, {
              "category.description": _withCtx((props) => [
                _createTextVNode(_toDisplayString(props.value.category ? props.value.category.description : '-'), 1)
              ]),
              "product_type.description": _withCtx((props) => [
                _createTextVNode(_toDisplayString(props.value.product_type ? props.value.product_type.description : '-'), 1)
              ]),
              price: _withCtx((props) => [
                _createTextVNode(_toDisplayString(_ctx.formatNumber(props.value.price)), 1)
              ]),
              discount: _withCtx((props) => [
                _createTextVNode(_toDisplayString(_ctx.formatNumber(props.value.discount)), 1)
              ]),
              video_display_name: _withCtx((props) => [
                _createTextVNode(_toDisplayString(props.value.video_display_name ? props.value.video_display_name : '-'), 1)
              ]),
              is_highlight: _withCtx((props) => [
                _createElementVNode("span", {
                  class: _normalizeClass(["badge", {
              'bg-success': props.value.is_highlight,
              'bg-danger': !props.value.is_highlight
            }])
                }, _toDisplayString(props.value.is_highlight ? _ctx.$t('labels.yes') : _ctx.$t('labels.no')), 3)
              ]),
              enabled: _withCtx((props) => [
                _createElementVNode("span", {
                  class: _normalizeClass(["badge", {
              'bg-success': props.value.enabled,
              'bg-danger': !props.value.enabled
            }])
                }, _toDisplayString(props.value.enabled ? _ctx.$t('labels.yes') : _ctx.$t('labels.no')), 3)
              ]),
              actions: _withCtx((props) => [
                _createElementVNode("div", _hoisted_50, [
                  _createElementVNode("div", _hoisted_51, [
                    (_ctx.hasPermission('read'))
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 0,
                          onClick: $event => (_ctx.view(props.value.id)),
                          class: "btn btn-xs btn-success",
                          "data-delay": "500",
                          "data-hasqtip": "0",
                          "aria-describedby": "qtip-0",
                          title: _ctx.$t('labels.buttons.view')
                        }, _hoisted_54, 8, _hoisted_52))
                      : _createCommentVNode("", true),
                    (_ctx.hasPermission('edit'))
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 1,
                          onClick: $event => (_ctx.edit(props.value.id)),
                          class: "btn btn-xs btn-warning",
                          "data-delay": "500",
                          "data-hasqtip": "0",
                          "aria-describedby": "qtip-0",
                          title: _ctx.$t('labels.buttons.edit')
                        }, _hoisted_57, 8, _hoisted_55))
                      : _createCommentVNode("", true),
                    (_ctx.hasPermission('delete'))
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 2,
                          onClick: $event => (_ctx.excluir(props.value.id)),
                          class: "btn btn-xs btn-danger",
                          "data-delay": "500",
                          "data-hasqtip": "1",
                          title: _ctx.$t('labels.buttons.remove')
                        }, _hoisted_60, 8, _hoisted_58))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              _: 1
            }, 8, ["is-loading", "columns", "rows", "total", "sortable", "messages", "onDoSearch"])
          ])
        ])
      ])
    ])
  ], 64))
}